import { render, staticRenderFns } from "./CopyQuoteDialog.vue?vue&type=template&id=02ddf6fc&scoped=true"
import script from "./CopyQuoteDialog.vue?vue&type=script&lang=js"
export * from "./CopyQuoteDialog.vue?vue&type=script&lang=js"
import style0 from "./CopyQuoteDialog.vue?vue&type=style&index=0&id=02ddf6fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ddf6fc",
  null
  
)

export default component.exports